import React, {Component} from 'react';
import {connect} from 'react-redux';

class TotalMinExposure extends Component {
    getClassName(value) {
        return Number(value) > 100 ? 'text-dark-red' : '';
    }
    render() {
        const {stackNumber, stacking} = this.props;
        const value = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(stackNumber);

        return (
            <div className="form-inline justify-content-end">
                <strong className="form-text">
                    Total min exp: <span className={this.getClassName(value)}>{value}%</span>
                </strong>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(TotalMinExposure);
